module.exports = __webpack_public_path__ + "static/media/forest_img.94bf996c.png";